jQuery(function(){
    let triggerElements = $(".slide-to-map");

    let action = _.debounce(() => {
        window.pixelpoint.utilities.scrollTo(".dce-map-related-offers", null, 0, false,() => {
            $(".init-medium-map").first().click();
        });
    },100);

    triggerElements.on("click",event => {
        action();
    });
});